/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { array, object, string } from "prop-types";
import { MainStory } from "./MainStory";
import { OtherStory } from "./OtherStory";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { getStoriesFromCollections } from "../../utils/collection";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";

import "./two-col-five-stories.m.css";

export const TwoColFiveStories = ({ collection, extraProp = "" }) => {
  const {
    show_timestamp,
    show_read_time,
    subheadline_of_first_story,
    show_row_title,
    show_column_separator,
    show_story_separator,
    show_row_separator,
    enable_sponsor_ad,
    sponsor_ad_details,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});
  const stories = getStoriesFromCollections(collection, 5);
  if (stories.length <= 0) {
    return null;
  }

  const [firstStory, ...remainingStories] = stories;
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));
  const device = useDeviceType();
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  return (
    <div className="row-component">
      <div styleName="two-col-five-stories">
        {show_row_title && (
          <CollectionTitle
            styles="two-col-five-stories"
            collection={collection}
            enableSponsorAd={enable_sponsor_ad}
            sponsorAdDetails={sponsor_ad_details}
            sponsorAdConfig={sponsorAdConfig}
            sectionSlug={sectionSlug}
          />
        )}
        <div styleName="stories-container">
          <div styleName="main-story-container">
            <MainStory
              story={firstStory}
              showBorder={
                (device === "mobile" && show_story_separator) || (device !== "mobile" && show_column_separator)
              }
              showHeroImage={true}
              showReadTime={show_read_time}
              showTimestamp={show_timestamp}
              showSubheadline={subheadline_of_first_story}
              sectionSlug={sectionSlug}
            />
          </div>
          <div
            styleName="remaining-stories"
            style={{
              border: show_column_separator || "none",
            }}
          >
            <div
              styleName="second-row"
              style={{
                border: show_column_separator || "none",
              }}
            >
              {remainingStories.slice(0, 2).map((story, index) => (
                <OtherStory
                  key={story.id}
                  story={story}
                  showReadTime={show_read_time}
                  showTimestamp={show_timestamp}
                  showBorder={show_story_separator && index !== remainingStories.length - 1}
                  sectionSlug={sectionSlug}
                />
              ))}
            </div>
            <div styleName="third-row">
              {remainingStories.slice(2, 4).map((story, index) => (
                <OtherStory
                  key={story.id}
                  story={story}
                  showReadTime={show_read_time}
                  showTimestamp={show_timestamp}
                  showBorder={show_story_separator && index + 2 !== remainingStories.length - 1}
                  sectionSlug={sectionSlug}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
};

TwoColFiveStories.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

TwoColFiveStories.storyLimit = 5;
